import { Box, Typography } from "@mui/material";
import {
  CartesianGrid,
  Label,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Primary } from "../../constants/Spalvos";

const Colors = [Primary, "#8e8989"];

const SlsKreiviuGrafikas = ({
  isLoading,
  pavadinimas,
  data,
  keys,
  refLinijaZemiau = 200,
  refLinijaAuksciau = 400,
  refLinijaAuksciauSpalva = "red",
  refLinijaZemiauSpalva = "orange",
  refLinijaZemiauPozicija = "insideBottomRight",
  refLinijaAuksciauPozicija = "insideBottomRight",
  dataKey = "menuo",
}) => {
  return (
    <>
      <Typography>{pavadinimas}</Typography>
      {isLoading ? (
        <Box
          width="100%"
          height="100%"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography>Duomenys kraunami...</Typography>
        </Box>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid />
            <XAxis dataKey={dataKey} />
            <YAxis type="number" allowDataOverflow />
            <Tooltip />
            {refLinijaZemiau && (
              <>
                <ReferenceLine
                  y={refLinijaZemiau}
                  stroke={refLinijaZemiauSpalva}
                  strokeDasharray="3 3"
                >
                  <Label
                    stroke={refLinijaZemiauSpalva}
                    strokeOpacity={0.6}
                    position={refLinijaZemiauPozicija}
                    value={refLinijaZemiau}
                  />
                </ReferenceLine>
              </>
            )}
            {refLinijaAuksciau && (
              <>
                <ReferenceLine
                  y={refLinijaAuksciau}
                  stroke={refLinijaAuksciauSpalva}
                  strokeDasharray="3 3"
                >
                  <Label
                    stroke={refLinijaAuksciauSpalva}
                    strokeOpacity={0.6}
                    position={refLinijaAuksciauPozicija}
                    value={refLinijaAuksciau}
                  />
                </ReferenceLine>
              </>
            )}
            {keys.map((k, index) => (
              <Line
                key={`line-${k}`}
                dataKey={k}
                type="linear"
                dot={false}
                stroke={Colors[index]}
                strokeWidth={3}
                connectNulls
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      )}
    </>
  );
};

export default SlsKreiviuGrafikas;
